var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnSortUnsorted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "48px",
    height: "48px",
    viewBox: "0,0,256,256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.33333,5.33333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.037,8.416c-0.579,-0.555 -1.494,-0.555 -2.073,0l-11.5,11c-0.443,0.424 -0.583,1.074 -0.355,1.643c0.228,0.569 0.778,0.941 1.391,0.941h23c0.612,0 1.164,-0.373 1.393,-0.941c0.228,-0.568 0.087,-1.219 -0.355,-1.643zM35.5,26h-23c-0.613,0 -1.164,0.373 -1.392,0.941c-0.228,0.568 -0.087,1.219 0.355,1.643l11.5,11c0.29,0.277 0.663,0.416 1.037,0.416c0.374,0 0.747,-0.139 1.037,-0.416l11.5,-11c0.442,-0.424 0.583,-1.074 0.355,-1.643c-0.228,-0.568 -0.78,-0.941 -1.392,-0.941z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnSortUnsorted);
export default __webpack_public_path__ + "static/media/icn-sort-unsorted.f01d41cfcf7db5ca6997e3e05873d1dd.svg";
export { ForwardRef as ReactComponent };